import SectionWithItems from './section_with_items';
export default class PriorTherapy extends SectionWithItems {

  sectionData() {
    let {population} = this.props;
    return population.data.prior_therapy;
  }

  submit() {
    let {population, onChange} = this.props;
    let {section_data} = this.state;
    population.data.prior_therapy = section_data;
    onChange(population.data);
  }

  sectionDetails() {
    return {title: 'Prior Therapy', subtitle: 'Therapy received more than 6 months ago.'};
  }
}
